// src/config/cloudProvider.js
export const CLOUD_PROVIDERS = {
    AZURE: 'azure',
    GCP: 'gcp'
};

export const getCloudProvider = () => {
    const provider = process.env.REACT_APP_CLOUD_PROVIDER || CLOUD_PROVIDERS.GCP;
    return provider ? provider.toLowerCase() : CLOUD_PROVIDERS.GCP;
};

export const isAzureProvider = () => getCloudProvider() === CLOUD_PROVIDERS.AZURE;

export const isGCPProvider = () => getCloudProvider() === CLOUD_PROVIDERS.GCP;
